var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[(_vm.error.statusCode === 404)?_c('h1',[_vm._v("Page not found")]):_c('h1',[_vm._v("An error occurred")]),_vm._v(" "),_c('nuxt-link',{attrs:{"to":"/"}},[_vm._v("Home page")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }